import { combineReducers } from 'redux'

import { alert } from './alert.reducer'
import { authentication } from './authentication.reducer'
import { theme } from './theme.reducer'
import { markets } from './market.reducer'


const rootReducer = combineReducers({
    authentication,
    alert,
    ui_red: theme,
    markets
})

export default rootReducer
